import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Gradient"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.5 3H4.5C4.10232 3.00046 3.72105 3.15864 3.43984 3.43984C3.15864 3.72105 3.00046 4.10232 3 4.5V19.5C3.00046 19.8977 3.15864 20.2789 3.43984 20.5602C3.72105 20.8414 4.10232 20.9995 4.5 21H19.5C19.8977 20.9995 20.2789 20.8414 20.5602 20.5602C20.8414 20.2789 20.9995 19.8977 21 19.5V4.5C20.9995 4.10232 20.8414 3.72105 20.5602 3.43984C20.2789 3.15864 19.8977 3.00046 19.5 3ZM16.5 19.5V16.5H13.5V19.5H10.5V16.5H7.5V13.5H10.5V10.5H7.5V7.5H10.5V4.5H13.5V7.5H16.5V4.5H19.5V19.5H16.5Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M13.5 7.5H10.5V10.5H13.5V7.5zM13.5 13.5H10.5V16.5H13.5V13.5zM16.5 10.5H13.5V13.5H16.5V10.5z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Gradient.vue"]]);
